import React, { forwardRef } from "react";
import Tooltip from "../Tooltip";

interface CustomInputProps {
  label?: string;
  inputId?: string;
  type?: string;
  value?: string | number;  // value is a string
  name?: string;
  id?: string;
  disabled?: boolean;
  iconRight?: any;
  tooltipText?: any;
  labelIcon?: any;
  inputClass?: any;
  placeholder?: string;
  formGroupClass?: string;
  register?: any;
  onKeyDown?: any;
}

const InputBox = forwardRef<HTMLInputElement, CustomInputProps>(({ value, label, name, id, disabled = false, placeholder, type, iconRight, inputClass, tooltipText, labelIcon, formGroupClass, onKeyDown, ...register }, ref) => (
  <div className={`form-group ${formGroupClass}`}>
    {label && <label htmlFor="input-field" className={`block text-md mb-2 font-medium text-gray-900 ${labelIcon ? 'flex items-center gap-2' : ''}`}>{label} {labelIcon && <Tooltip text={tooltipText}><span className="cursor-pointer">{labelIcon}</span></Tooltip>} </label>}
    <div className="icon-group relative">
      <input
        ref={ref}
        type={type}
        value={value}
        name={name}
        id={id}
        disabled={disabled}
        className={`form-control ${inputClass}`}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        {...register}
      />
      {iconRight && <span className="absolute top-1/2 -translate-y-1/2 right-4 text-gray-600 text-xl">{iconRight}</span>}
    </div>
  </div>
)
);

export default InputBox;